import React from 'react';

const Donate = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
      <h2>DONATION</h2>
      <p>You can donate us to accelerate our project work which can motivate our best scholars to join research centers to upgrade the existing technologies and develop the indigenization in research field.</p>

      <p>Donors desirous of becoming the member of UJSS, can deposit the requisite amount in the S.B.</p>
      <p>A/c Name: Utkal Jagruti Seva Sangh</p>
      <p>A/c No: 19010100006491</p>
      <p>I.F.S.C./ R.T.G.S. Code: JSBL0000019</p>
      <p>Bank Name: Janakalyan Sahakari Bank limited</p>
      <p>Contact No: 9323166645 (Shri Manoranjan Panda)</p>
    </div>
  );
};

export default Donate;
